import Box from '@mui/material/Box';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './ErrorAlert.css';

const ErrorAlert = ({ children }) => {
    return (
        <Box className="error-alert">
            <Box display="flex" alignItems="center">
                <CancelOutlinedIcon fontSize="medium" color="error" sx={{ paddingRight: '9px' }} />
                <Box className="error-alert-message">{children}</Box>
            </Box>
        </Box>
    );
};

export default ErrorAlert;
